module.exports = __webpack_public_path__ + "img/13.40053045.webp";